import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Armé mi mini cápsula de 5 productos en dos semanas. Con el tomo de proveedores evité comprar en un mayorista que me iba a dar tela de mala calidad. Vendí todo en el primer drop.',
  name: 'Florencia M.',
  location: 'Rosario · Ropa Oversize',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/0b522287-cfe4-4ccf-9781-0c38d2e3d235.jpg'
}, {
  quote: 'La calculadora de costos me salvó. Estaba vendiendo por debajo del margen real y no me daba cuenta. Subí los precios y la gente igual compró. No puedo creer que antes vendía a pérdida.',
  name: 'Ezequiel T.',
  location: 'Córdoba · Indumentaria Urbana',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2c0595-1eea-431f-a991-351bd2295f48.jpg'
}, {
  quote: 'El tomo de Meta Ads para ropa es increíble. Con un presupuesto mínimo conseguí mis primeros pedidos de personas que no me conocían. Mi marca ya tiene identidad propia.',
  name: 'Camila R.',
  location: 'Buenos Aires · Moda Femenina',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/7cf62f48-efdb-43df-a224-015d4d12f8b2.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-153" data-mp="c6252gjx3nol">
      <div className="mx-auto max-w-6xl px-5 pt-[47px] pb-16 sm:pb-20" data-id="element-154" data-mp="c8ojn05873gb">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-155" data-mp="zx7thk3xboai">
          💬 Lo que dicen los que ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-156" data-mp="q761wicd3nqu">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-157" data-mp="v44xz6fl64ro" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" data-id="element-158" data-mp="1sjfq7jpg7sef">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-159" data-mp="1ojf89p354z2m" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-160" data-mp="1jkke5qzq3o37">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-161" data-mp="19rdd2ic0mu8x">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-162" data-mp="14ud5u43fjlg8" />
                <div data-id="element-163" data-mp="vswvfwcm7jc0">
                  <div className="text-sm font-bold text-white" data-id="element-164" data-mp="vrc3mehoqehu">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-165" data-mp="qtak5sgckd5u">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}